import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CustomSelect from '../Utilities/CustomSelect'
import { AddNewMarketerVM } from '../../Structure/ViewModels/Admin/AddNewMarketerVM'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods'
import CustomPhoneInput from '../Utilities/CustomPhoneInput'

const AddNewMarketer = () => {
    const [vm , setVm] = useState<{viewModel:AddNewMarketerVM}>({viewModel:new AddNewMarketerVM()})
    const control = vm.viewModel
    useEffect(()=>{ control.subscribeUpdate(setVm); GeneralMethods.deActivateForm('loginForm') },[])


  return (
    <Container>
        
        <Row>
            <h3 className='py-5 text-center'>انشاء حساب مسوق جديد</h3>
            <form id='loginForm' action="">
            <Row className='py-4 justify-content-center'>
                <Col lg={8} className='p-3'>
                    <div className='d-flex flex-column'>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-3'>اسم المسوق</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                            <div className=' my-auto'>
                                <input type="text" autoComplete='off' className='input-field my-auto w-100' value={control.Data.name} onChange={a=>control.Name = a.target.value} />
                            </div>
                            </Col>
                        </Row> 
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>الايميل (اختياري)</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <input type="text" autoComplete='off' className='input-field my-auto w-100'  value={control.Data.email} onChange={a=>control.Email = a.target.value} />
                                </div>
                            </Col>
                        </Row>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>الموبايل</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <CustomPhoneInput className='input-field my-auto w-100' countryKey={control.Data.dial_code} value={control.Data.mobile} setCountryKey={a=>control.DialCode=a} setNumber={a=>control.Mobile=a}/>
                                </div>
                            </Col>
                        </Row>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>الحساب البنكي (اختياري)</label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.Data.bank_account} onChange={a=>control.BankAccount = a.target.value} />
                                </div>
                            </Col>
                        </Row>
                        <Row className=' justify-content-between'>
                            <Col md={6}>
                                <label htmlFor="" className='my-auto p-4'>النسبة </label>
                            </Col>
                            <Col md={6} className='d-flex flex-column'>
                                <div className=' my-auto'>
                                    <input type="text" className='input-field my-auto w-100' autoComplete='off' value={control.Data.commission} onChange={a=>control.Commission = a.target.value} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <div className='d-flex justify-content-center'>
                <button className='button-I btn-cl-I px-5 py-2 fw-bold' onClick={()=>control.send()}>اضافة</button>
            </div>
            </form>
        </Row>
        
    </Container>
  )
}

export default AddNewMarketer
